import Vue from "vue";
import Vuex from "vuex";
import anime from "animejs"; // anime

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: undefined,
    allData: {
      allWebzine: [],
      allDataRoom: [],
      allMovies: []
    }
  },
  getters: {
    allData: s => s.allData
  },
  mutations: {
    setUser(s, p) {
      s.user = p;
    },
    loadingAnime() {
      // 로딩애니메이션
      anime({
        targets: ".icon-loading",
        rotate: "1turn",
        duration: 3000,
        loop: true,
        easing: "linear"
      });
    }
  },
  actions: {},
  modules: {}
});
